import { render } from "./SupplierCard.vue?vue&type=template&id=7b76ea54"
import script from "./SupplierCard.vue?vue&type=script&lang=js"
export * from "./SupplierCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__